import Minter from './Minter'

function App() {
  return (
    <div>
        <Minter />
    </div>
  );
}

export default App
